import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useModalBehavior, useAuth } from 'hooks'
import { Button, Modal, ModalNavHeader, TextInput } from 'elements'
import ModalContent from 'components/app/ModalContent'
import useCompanyCreate from '../hooks/useCompanyCreate'

export default function CreateCompanyModal({ modal }) {
  const [companyName, setCompanyName] = useState('')
  const [companyLegalName, setCompanyLegalName] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const modalBehavior = useModalBehavior(modal, {})
  const [createCompany] = useCompanyCreate()
  const history = useHistory()
  const { login, currentOrg } = useAuth()

  const handleCreateCompany = async () => {
    setSubmitting(true)

    const { company } = await createCompany({
      name: companyName,
      legalName: companyLegalName,
      organizationId: currentOrg.id,
    })

    history.push(`/orgs/${currentOrg.slug}/companies/${company.id}/reports`)

    //avoid having to refresh to see updated user menu in dropdown
    login()

    modal.onClose()
  }

  const canContinue = companyName.length

  return (
    <Modal modal={modalBehavior}>
      <ModalNavHeader onClose={modal.onClose} titleText="Add a New Client" />
      <ModalContent>
        <TextInput
          value={companyName}
          autoFocus
          onChange={(event) => setCompanyName(event.target.value)}
          placeholder="Name"
          mb="large"
        />
        <TextInput
          value={companyLegalName}
          onChange={(event) => setCompanyLegalName(event.target.value)}
          placeholder="Legal Name"
          mb="large"
        />
      </ModalContent>
      <Modal.Footer display="flex" alignItems="center">
        <Button
          mr="medium"
          kind="secondary"
          onClick={handleCreateCompany}
          disabled={submitting || !canContinue}
        >
          {!submitting ? 'Create Client' : 'Creating...'}
        </Button>
        <Button onClick={() => modal.onClose()} mr="xxxlarge">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
